// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 3840px) {
        
    .login-modal-container{
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 100000;
        width: 50%;
        max-width: 500px;
        min-height: 408px;
        border-radius: 10px;
        background: #FFBD59;
    }

    .login-header-container{
        position:absolute;
        top:0%;
        width: 100%;
    }

    .login-header-button{
        width:50%;
        min-height: 80px;
        border: none;
        background: #353535;
        font-size: 24px;
        font-family: 'Kanit';
        color: white;
    }

    .login-header-button-active{
        width:50%;
        min-height: 80px;
        border: none;
        background: #1B1B1B;
        font-size: 24px;
        font-family: 'Kanit';
        color: white;
    }

    .login-modal-content{
        width: 70%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
    }

    .login-username-input{
        margin: 10px 0px;
        line-height: 2.5em;
        z-index: 10000;
        padding-left: 10px;
        text-align: center !important;
    }

    .login-modal-content h1{
        color: #022452;
        text-shadow: 1px 1px 2px #000000;
    }

    .login-modal-content img{
        cursor: pointer
    }

    .login-button-close{
        position: absolute;
        right: 0px;
        top: -40px;
        border-radius: 13px;
        width: 26px;
        height: 26px;
        border:none;
        box-shadow: 1px 1px 4px 0 #000000;
        background: #022452;
        font-size: 26px;
        text-align: center;
        line-height: 00%;
        color:#FFBD59;
        padding-bottom:5px;
    }

    .login-modal-no-account-container{
        display: flex;
        margin-top: 10px;
    }

    .login-modal-no-account-text{
        margin: 0;
        color: var(--menu-text-color);
    }

    .login-modal-no-account-link{
        color: #DAA520;
        margin-left : 10px;
        font-weight: bold;
        text-decoration: underline;
    }

    .login-error-message{
        color: red;
        font-weight: bold;
        font-size: 16px;
        text-shadow: 1px 1px 4px #000000;
        margin: 0px;
    }

    .login-button{
        position: absolute;
        bottom:0px;
        width: 100%;
        background: radial-gradient(100% 100% at 50% 0,#fff2ca 16.67%,#bda362 61.98%,#977525 100%);
        font-family: 'Kanit';
        font-size: 16px;
        height: 50px;
    }

    .login-input-container{
        position:relative;
        width: 100%;
    }

    .login-button-image{
        position: absolute;
        width: 20px;
        height: 20px;
        z-index: 10001;
        left: 10px;
        top: 1.7em;
    }

    .ant-input[type="password"]{
        text-align: center;
        margin-left: 15px;
    }
}

@media screen and (max-width: 540px) {
        
    .login-modal-container{
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 100000;
        min-width: 80%;
        min-height: 408px;
        border-radius: 10px;
        background: #FFBD59;
    }

    .login-header-container{
        position:absolute;
        top:0%;
        width: 100%;
    }

    .login-header-button{
        width:50%;
        min-height: 80px;
        border: none;
        background: #353535;
        font-size: 24px;
        font-family: 'Kanit';
        color: white;
    }

    .login-header-button-active{
        width:50%;
        min-height: 80px;
        border: none;
        background: #1B1B1B;
        font-size: 24px;
        font-family: 'Kanit';
        color: white;
    }

    .login-modal-content{
        width: 70%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
    }

    .login-username-input{
        margin: 10px 0px;
        line-height: 2.5em;
        z-index: 10000;
        padding-left: 10px;
        text-align: center !important;
    }

    .login-modal-content h1{
        color: #022452;
        text-shadow: 1px 1px 2px #000000;
    }

    .login-button-close{
        position: absolute;
        right: 20px;
        top: -40px;
        border-radius: 13px;
        width: 26px;
        height: 26px;
        border:none;
        box-shadow: 1px 1px 4px 0 #000000;
        background: #022452;
        font-size: 26px;
        text-align: center;
        line-height: 00%;
        color:#FFBD59;
        padding-bottom:5px;
    }

    .login-modal-no-account-container{
        display: flex;
        margin-top: 10px;
    }

    .login-modal-no-account-text{
        margin: 0;
        color: var(--menu-text-color);
    }

    .login-modal-no-account-link{
        color: #DAA520;
        margin-left : 10px;
        font-weight: bold;
        text-decoration: underline;
    }

    .login-error-message{
        color: red;
        font-weight: bold;
        font-size: 16px;
        text-shadow: 1px 1px 4px #000000;
        margin: 0px;
    }

    .login-button{
        position: absolute;
        bottom:0px;
        width: 100%;
        background: radial-gradient(100% 100% at 50% 0,#fff2ca 16.67%,#bda362 61.98%,#977525 100%);
        font-family: 'Kanit';
        font-size: 16px;
        height: 50px;
    }

    .login-input-container{
        position:relative;
        width: 100%;
    }

    .login-button-image{
        position: absolute;
        width: 20px;
        height: 20px;
        z-index: 10001;
        left: 10px;
        top: 1.7em;
    }

    .ant-input[type="password"]{
        text-align: center;
        margin-left: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/modals/LoginModal.css"],"names":[],"mappings":"AAAA;;IAEI;QACI,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,eAAe;QACf,UAAU;QACV,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,MAAM;QACN,WAAW;IACf;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;QACd,kBAAkB;QAClB,6BAA6B;IACjC;;IAEA;QACI,cAAc;QACd,gCAAgC;IACpC;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,UAAU;QACV,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,WAAW;QACX,iCAAiC;QACjC,mBAAmB;QACnB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,6BAA6B;IACjC;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,iBAAiB;QACjB,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB,eAAe;QACf,gCAAgC;QAChC,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,0FAA0F;QAC1F,oBAAoB;QACpB,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,UAAU;QACV,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;QACI,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,MAAM;QACN,WAAW;IACf;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;QACd,kBAAkB;QAClB,6BAA6B;IACjC;;IAEA;QACI,cAAc;QACd,gCAAgC;IACpC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,WAAW;QACX,iCAAiC;QACjC,mBAAmB;QACnB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,6BAA6B;IACjC;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,iBAAiB;QACjB,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB,eAAe;QACf,gCAAgC;QAChC,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,0FAA0F;QAC1F,oBAAoB;QACpB,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,UAAU;QACV,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;AACJ","sourcesContent":["@media screen and (max-width: 3840px) {\n        \n    .login-modal-container{\n        display:flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        z-index: 100000;\n        width: 50%;\n        max-width: 500px;\n        min-height: 408px;\n        border-radius: 10px;\n        background: #FFBD59;\n    }\n\n    .login-header-container{\n        position:absolute;\n        top:0%;\n        width: 100%;\n    }\n\n    .login-header-button{\n        width:50%;\n        min-height: 80px;\n        border: none;\n        background: #353535;\n        font-size: 24px;\n        font-family: 'Kanit';\n        color: white;\n    }\n\n    .login-header-button-active{\n        width:50%;\n        min-height: 80px;\n        border: none;\n        background: #1B1B1B;\n        font-size: 24px;\n        font-family: 'Kanit';\n        color: white;\n    }\n\n    .login-modal-content{\n        width: 70%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        margin-top: 30px;\n    }\n\n    .login-username-input{\n        margin: 10px 0px;\n        line-height: 2.5em;\n        z-index: 10000;\n        padding-left: 10px;\n        text-align: center !important;\n    }\n\n    .login-modal-content h1{\n        color: #022452;\n        text-shadow: 1px 1px 2px #000000;\n    }\n\n    .login-modal-content img{\n        cursor: pointer\n    }\n\n    .login-button-close{\n        position: absolute;\n        right: 0px;\n        top: -40px;\n        border-radius: 13px;\n        width: 26px;\n        height: 26px;\n        border:none;\n        box-shadow: 1px 1px 4px 0 #000000;\n        background: #022452;\n        font-size: 26px;\n        text-align: center;\n        line-height: 00%;\n        color:#FFBD59;\n        padding-bottom:5px;\n    }\n\n    .login-modal-no-account-container{\n        display: flex;\n        margin-top: 10px;\n    }\n\n    .login-modal-no-account-text{\n        margin: 0;\n        color: var(--menu-text-color);\n    }\n\n    .login-modal-no-account-link{\n        color: #DAA520;\n        margin-left : 10px;\n        font-weight: bold;\n        text-decoration: underline;\n    }\n\n    .login-error-message{\n        color: red;\n        font-weight: bold;\n        font-size: 16px;\n        text-shadow: 1px 1px 4px #000000;\n        margin: 0px;\n    }\n\n    .login-button{\n        position: absolute;\n        bottom:0px;\n        width: 100%;\n        background: radial-gradient(100% 100% at 50% 0,#fff2ca 16.67%,#bda362 61.98%,#977525 100%);\n        font-family: 'Kanit';\n        font-size: 16px;\n        height: 50px;\n    }\n\n    .login-input-container{\n        position:relative;\n        width: 100%;\n    }\n\n    .login-button-image{\n        position: absolute;\n        width: 20px;\n        height: 20px;\n        z-index: 10001;\n        left: 10px;\n        top: 1.7em;\n    }\n\n    .ant-input[type=\"password\"]{\n        text-align: center;\n        margin-left: 15px;\n    }\n}\n\n@media screen and (max-width: 540px) {\n        \n    .login-modal-container{\n        display:flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        z-index: 100000;\n        min-width: 80%;\n        min-height: 408px;\n        border-radius: 10px;\n        background: #FFBD59;\n    }\n\n    .login-header-container{\n        position:absolute;\n        top:0%;\n        width: 100%;\n    }\n\n    .login-header-button{\n        width:50%;\n        min-height: 80px;\n        border: none;\n        background: #353535;\n        font-size: 24px;\n        font-family: 'Kanit';\n        color: white;\n    }\n\n    .login-header-button-active{\n        width:50%;\n        min-height: 80px;\n        border: none;\n        background: #1B1B1B;\n        font-size: 24px;\n        font-family: 'Kanit';\n        color: white;\n    }\n\n    .login-modal-content{\n        width: 70%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        margin-top: 30px;\n    }\n\n    .login-username-input{\n        margin: 10px 0px;\n        line-height: 2.5em;\n        z-index: 10000;\n        padding-left: 10px;\n        text-align: center !important;\n    }\n\n    .login-modal-content h1{\n        color: #022452;\n        text-shadow: 1px 1px 2px #000000;\n    }\n\n    .login-button-close{\n        position: absolute;\n        right: 20px;\n        top: -40px;\n        border-radius: 13px;\n        width: 26px;\n        height: 26px;\n        border:none;\n        box-shadow: 1px 1px 4px 0 #000000;\n        background: #022452;\n        font-size: 26px;\n        text-align: center;\n        line-height: 00%;\n        color:#FFBD59;\n        padding-bottom:5px;\n    }\n\n    .login-modal-no-account-container{\n        display: flex;\n        margin-top: 10px;\n    }\n\n    .login-modal-no-account-text{\n        margin: 0;\n        color: var(--menu-text-color);\n    }\n\n    .login-modal-no-account-link{\n        color: #DAA520;\n        margin-left : 10px;\n        font-weight: bold;\n        text-decoration: underline;\n    }\n\n    .login-error-message{\n        color: red;\n        font-weight: bold;\n        font-size: 16px;\n        text-shadow: 1px 1px 4px #000000;\n        margin: 0px;\n    }\n\n    .login-button{\n        position: absolute;\n        bottom:0px;\n        width: 100%;\n        background: radial-gradient(100% 100% at 50% 0,#fff2ca 16.67%,#bda362 61.98%,#977525 100%);\n        font-family: 'Kanit';\n        font-size: 16px;\n        height: 50px;\n    }\n\n    .login-input-container{\n        position:relative;\n        width: 100%;\n    }\n\n    .login-button-image{\n        position: absolute;\n        width: 20px;\n        height: 20px;\n        z-index: 10001;\n        left: 10px;\n        top: 1.7em;\n    }\n\n    .ant-input[type=\"password\"]{\n        text-align: center;\n        margin-left: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
